export function getUserName(firstName?: string, lastName?: string, displayName?: string | null): string {
    if (firstName && lastName) {
        return `${firstName} ${lastName.substring(0, 1)}.`;
    }

    return firstName || lastName || displayName || '';
}
